import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.css']
})
export class BreadcrumbComponent implements OnInit {
  selectedIbuName: any = '';
  selectedFunctionName: any = '';
  selectedTowerName: any = '';
  users: any = {};
  userRoll: number = 0;
  constructor() { 
    this.users = JSON.parse(localStorage.getItem('user'));

    if (this.users && this.users.userData) {
        this.userRoll = this.users.userData.userRoll;
    
    }
    this.selectedIbuName = localStorage.getItem('ibuName');
    this.selectedFunctionName = localStorage.getItem('functionName');
    this.selectedTowerName = localStorage.getItem('selectedTowerName');
  }

  ngOnInit(): void {
  }

}
